module.exports = __webpack_public_path__ + "img/phone-with-icons.490bf374.png";